import { defineStore } from 'pinia'
import { ref } from '@nuxtjs/composition-api'

export const useMetaModel = defineStore('meta', () => {
  const session = ref<string | null>(null)
  const guest = ref<string | number | null>(null)

  return {
    session,
    guest
  }
})
